import { defineComponent as n, openBlock as o, createBlock as a, unref as l, mergeProps as i, withCtx as c, createElementVNode as p } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const f = /* @__PURE__ */ n({
  name: "IconPieChartInSquareFilled",
  __name: "IconPieChartInSquareFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(r) {
    const t = r;
    return (d, e) => (o(), a(l(m), i(t, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        p("path", {
          "fill-rule": "evenodd",
          d: "M18 3.25A2.75 2.75 0 0 1 20.75 6v12A2.75 2.75 0 0 1 18 20.75H6A2.75 2.75 0 0 1 3.25 18V6A2.75 2.75 0 0 1 6 3.25h12m-6.5 5.944c0-.521-.428-.954-.937-.84a4.26 4.26 0 0 0-2.99 2.52 4.251 4.251 0 0 0 5.553 5.553 4.25 4.25 0 0 0 2.52-2.99c.114-.509-.319-.937-.84-.937h-2.362a.945.945 0 0 1-.944-.944V9.194m2.437-2.34C13.428 6.74 13 7.173 13 7.694v2.362A.945.945 0 0 0 13.944 11h2.362c.521 0 .954-.428.84-.937a4.26 4.26 0 0 0-3.21-3.209",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
